// inv/src/components/ui/table.jsx
import { cn } from "../../lib/utils";

const Table = ({ columns, data, className, renderCell, onRowClick }) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className={cn("w-full border-collapse border border-gray-200 shadow-sm", className)}>
        <thead className="bg-gray-100">
          <tr>
            {columns.map((col, index) => (
              <th key={index} className="px-4 py-2 text-left text-sm font-medium text-gray-700 border border-gray-300 ">
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="border border-gray-200 transition-colors hover:bg-gray-50 "
                onClick={() => onRowClick?.(row)}
              >
                {columns.map((col, colIndex) => (
                  <td key={colIndex} className="px-4 py-2 text-sm text-gray-900 border border-gray-200">
                    {renderCell ? renderCell(row[col.accessor], col, row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="px-4 py-4 text-center text-gray-500">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

Table.displayName = "Table";

export { Table };
